import { graphql } from 'src/gql';

export const DISMISS_ANNOUNCEMENT = graphql(/* GraphQL */ `
  mutation DismissAnnouncement($input: DismissAnnouncementInput!) {
    dismissAnnouncement(input: $input) {
      success
    }
  }
`);
